import { isCash, materialText } from '../core/packet';
import type { Packet } from '../core/packet';
import type { SinkEntity } from '../core/entities';
import type { SimState } from '../core/state';

export const DEPOSIT_METHOD_NAME = 'deposit';

export type TreasuryMethodName = typeof DEPOSIT_METHOD_NAME;

/**
 * Your own books, as opposed to the market — the counterparty you sell *to*. The market prices goods
 * and hands back proceeds; the treasury takes proceeds and puts them in an account.
 * Which account is the sink's own business: a cash sink banks spending money, a research sink banks
 * research.
 *
 * It is the only function in the game with a side effect on the economy, and it sits at the very end
 * of the stream — exactly where RxJS says to keep one.
 */
function depositProceeds(state: SimState, sink: SinkEntity, packet: Packet): number {
  if (!isCash(packet.material)) {
    throw new Error(`deposit cannot accept a ${materialText(packet.material)} packet`);
  }
  const amount = packet.material.cash;
  if (sink.sinkType === 'cash') {
    state.economy.cash += amount;
    state.economy.saleCount += 1;
  } else {
    state.economy.research += amount;
  }
  return amount;
}

export class TreasuryService {
  /**
   * Deliberately not keyed by material: proceeds have forgotten what they used to be, so crediting
   * a per-material production gate is the selling operator's job, not the treasury's.
   */
  static readonly deposit = depositProceeds;
}
